<div class="screen-element menu-showcase">
  <div class="title"><text-widget [text]="getTranslator().tr(title)" [color]="'white'"></text-widget></div>

  <div class="items">
    @for (t of items; track t) {
      <div>
        <text-widget [text]="getTranslator().tr(t)" [boxed]="true" [color]="'white'"></text-widget>
      </div>
    }
  </div>
  <div class="text">
    @for (t of text; track t) {
      <div>
        <text-widget [text]="getTranslator().tr(t)" [color]="'white'"></text-widget>
      </div>
    }
  </div>
</div>